export const LEGACY_ROUTE_NAME = 'DO_NOT_USE_ROUTER';
export const LOCAL_STATE_STORAGE_KEY = 'LBX_FRONTEND_LOCALSTATE';
export const SESSION_STATE_STORAGE_KEY = 'LBX_FRONTEND_SESSIONSTATE';
export const RELOAD_SITES = 'RELOAD_SITES';
